var map = {
	"./alterac-banner.png": 69319,
	"./blackhearts-banner.png": 4317,
	"./boe-banner.png": 70165,
	"./braxis-banner.png": 41076,
	"./cursed-banner.png": 704,
	"./dragon-shire-banner.png": 6628,
	"./garden-banner.png": 99924,
	"./hanamura-banner.png": 99424,
	"./haunted-mines-banner.png": 48971,
	"./shrines-banner.png": 31979,
	"./sky-temple-banner.png": 14104,
	"./spider-banner.png": 80432,
	"./towers-of-doom-banner.png": 53327,
	"./volskaya-banner.png": 7513,
	"./warhead-banner.png": 17035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24946;